<template>
  <div class="filter-modal filter-block products-filters-view brand-manitou" >
    <div class="content ">
      <a class="close-button" v-on:click="$emit('close');">
        <i class="fas fa-times"></i>
      </a>

      <h3 class="filter-title">{{ displayFilterTitle(filter) }}</h3>
      <div class="slider-container horizontal-slider" v-if="filter.type === 'slider' && !isVertical">
        <div class="columns is-inline-flex is-vcentered slider-inputs">
          <div class="column is-narrow">{{ $t("from") }}</div>
          <div class="column is-narrow input-column">
            <b-input
                v-model="filter.minValue"
                size="is-large"
                autocomplete="new-password"
                @blur="updateSliderFromInput(index)"
                rounded
            />
          </div>
          <div class="column is-narrow">{{ $t("to") }}</div>
          <div class="column is-narrow input-column">
            <b-input
                v-model="filter.maxValue"
                size="is-large"
                autocomplete="new-password"
                @blur="updateSliderFromInput(index)"
                rounded
            />
          </div>
          <div class="column is-narrow">{{ filter.unit }}</div>
        </div>
        <div class="columns is-vcentered is-mobile slider-range">
          <div class="column edges is-narrow first-edge">{{ filter.min }}</div>
          <div class="column">
            <vue-slider
                v-model="filter.slider"
                :dotSize="38"
                :min="filter.min"
                :max="filter.max"
                :interval="1"
                :height="15"
                :tooltip-formatter="filter.formatter"
                :tooltip="'always'"
                :tooltip-placement="['top', 'bottom']"
                :tooltipStyle="{'class':'new'}"
                @change="updateSlide(index)"
            />
          </div>
          <div class="column edges is-narrow last-edge">{{ filter.max }}</div>
        </div>
      </div>

      <div class="slider-container vertical-slider" v-if="filter.type === 'slider' && isVertical">
        <div class="columns is-inline-flex is-vcentered slider-inputs">
          <div class="column is-narrow">{{ $t("from") }}</div>
          <div class="column is-narrow input-column">
            <b-input
                v-model="filter.minValue"
                size="is-large"
                autocomplete="new-password"
                @blur="updateSliderFromInput(index)"
                rounded
            />
          </div>
          <div class="column is-narrow">{{ $t("to") }}</div>
          <div class="column is-narrow input-column">
            <b-input
                v-model="filter.maxValue"
                size="is-large"
                autocomplete="new-password"
                @blur="updateSliderFromInput(index)"
                rounded
            />
          </div>
          <div class="column is-narrow">{{ filter.unit }}</div>
        </div>
        <div class=" is-vcentered is-mobile slider-range">


          <div class=" edges is-narrow last-edge">{{ filter.max }}</div>
            <vue-slider
                v-model="filter.slider"
                :dotSize="38"
                :min="filter.min"
                :max="filter.max"
                :interval="1"
                :height="450"
                :width="250"
                :tooltip-formatter="filter.formatter"
                :tooltip="'always'"
                :tooltip-placement="['left', 'right']"
                :tooltipStyle="{'class':'new'}"
                @change="updateSlide(index)"
                direction="btt"
            />
          <div class="edges is-narrow first-edge">{{ filter.min }}</div>

        </div>
      </div>

      <div v-if="filter.type === 'select' || filter.type === 'boolean'">

          <b-button
              v-for="option in filter.options"
              :value="option.code"
              :key="option.code"
              rounded
              class="button  is-large is-rounded is-uppercase switch-button"
              :class="{'switch-active': filter.value===option.code}"
              @click="selectOption(option.code)"

          >{{ option.label }}</b-button>

      </div>

      <div class="is-centered is-size-5 is-size-6-mobile results-count">
        <template>
          <strong>{{ $tc('results_count', total) }}</strong>
        </template>
      </div>

      <div class="has-text-centered">
        <b-button rounded class="button is-primary is-large is-rounded is-uppercase is-background-color-red" @click="search();$emit('close')">Valider <span class="fa fa-check"></span></b-button>
      </div>

    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";

import formMixins from "@/common/mixins/form";
import filtersMixins from "@/common/mixins/filters";

import {convertFiltersValuesBackToMetric} from "@/common/helpers";
import {mapState} from "vuex";

export default {
  name: "FilterModal",
  components: {
    VueSlider
  },
  mixins: [
    formMixins,
    filtersMixins
  ],
  props : {
    filters: {
      type:Array,
      require:true,
      default : ()=>[]
    },
    filter : {
      type:Object,
      require:true,
      default:null
    },
    index : {
      type:Number,
      require:true,
      default : 0
    }
  },
  computed: {
    ...mapState({
      total: state => state.searchMachines.total,
      results : state => state.searchMachines.results
    }),
    isVertical() {
      if(this.filter.attribute.indexOf('height')>-1)
        return true;
      else return false;
    }
  },

  methods : {
    debounceSearch: _.debounce(function () {
      this.search();
    }, 500),
    search() {
    //  console.log(this.filter)
      this.$store.commit("searchMachines/setFilters", this.filters);
      this.$root.$emit('research-machines')
    },
    updateSlide(index) {
      this.updateInputsFromSlider(index);
      this.$store.commit('searchMachines/setFirstLoad',false);
      this.debounceSearch();
    },
    selectOption(code) {
      this.filter.value=code;
      this.$store.commit('searchMachines/setFirstLoad',false);
      this.debounceSearch();
    },


  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/config/_config.scss";

.filter-modal {
  background: #ffffff;
  border-radius: 20px;

  .filter-title {
    font-size:1.7em;
    font-weight:900;
    margin-bottom:35px;
  }

.content {
  padding: 2rem;
  position: relative;
}

  .select-container {
    justify-content:center;
  }

.close-button {
  position: absolute;
  right: 25px;
  top: 20px;
  font-size: 1.5rem;
  font-weight: lighter;
}

  .button {
    margin:20px auto;
    span {margin-left:20px}
  }
}

.switch-button {
  background-color:$white;
  color:$blackish;
  display:block;
  border-color:$white;

  &:hover {
    border-color:$grey-light;
  }

  &.switch-active {
    color:$white;
    background-color:$blackish;
    border-color:$blackish;
  }
}



.modal-close {
  display: none
}
</style>